import React from "react";
import { FormControl, FormGroup, InputGroup } from "react-bootstrap";

function CustomInput({
  label,
  id,
  type = "text",
  value,
  onChange,
  placeholder,
  icon,
  iconClick,
  className,
  inputContainerClassName,
  disabled,
}) {
  const handleIconClick = () => {
    document?.getElementById(id)?.focus();
    iconClick && iconClick();
  };

  return (
    <FormGroup className={className}>
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      <InputGroup className="d-flex align-items-center">
        <FormControl
          id={id}
          onChange={onChange}
          className={inputContainerClassName}
          style={{ paddingRight: 55, borderRadius: 6 }}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
        />
        {icon && (
          <div
            style={{
              position: "absolute",
              right: 20,
              zIndex: 99999,
            }}
            onClick={handleIconClick}>
            {icon}
          </div>
        )}
      </InputGroup>
    </FormGroup>
  );
}

export default CustomInput;
